import axiosInstance from '../axios/axiosInstance';
import { Lecture } from '../model/response';

export const LESSON_PAGE_SIZE = 9;

export const findAllLectures = async (subjectId?: string) => {
  const { data } = await axiosInstance.get<Lecture[]>('lectures', { params: { subjectId, fromCMS: true } });
  return data;
};

export const findLectureById = async (id: string) => {
  const { data } = await axiosInstance.get<Lecture>(`lectures/${id}`);
  return data;
};

export const toggleLectureWebviewActive = async (id: string) => {
  await axiosInstance.patch(`lectures/${id}/toggle-web-view-active`);
};
